// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Forms_wrapper__3sGTr","actionsDropdownWrapper":"Forms_actionsDropdownWrapper__qUibl"};